import React, { useState } from 'react';
import { SaveFormulario } from '@services/Formulario/Index';
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import ButtonComp from '@components/UI/Button/Index.jsx';
import SurveyCreatorComponent from '@components/Modals/Admin/SurveyCreatorModal/Index';

const CreateFormulario = ({ onSave }) => {
  const [visible, setVisible] = useState(false);

  const handleOpen = () => setVisible(true);
  const handleClose = () => setVisible(false);

  const handleSaveFormulario = async (json) => {
    try {
      SweetAlert.loading();

      const payload = {
        json: JSON.stringify(json),
        flgStatus: true,
        flgModelo: true,
      };

      const result = await SaveFormulario(payload);

      SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');
      onSave(result);
      handleClose();
    } catch (error) {

      const errorMessage = error.parsed?.message || 'Não foi possível salvar o formulário.';

      SweetAlert.error('Erro ao cadastrar', errorMessage);
      console.error(error);
    }
  };

  return (
    <div className='row'>

      <div className="p-3 ms-3">
        <h3> - Observação: Ao clicar no botão abaixo, um modal será exibido para criação dos formulários.</h3>
      </div>

      <div className="col-12 col-sm-6 col-md-4 col-lg-3">

        <ButtonComp
          title="CRIAR FORMULÁRIO"
          type="button"
          onClick={handleOpen}
          buttonColor="#125578"
          classnameIcon="fa-solid fa-pen-ruler"
          hoverMessage="Abrir editor de formulário"
        />
      </div>

      <SurveyCreatorComponent
        open={visible}
        initialJson={{}}
        onSave={handleSaveFormulario}
        onClose={handleClose}
      />

    </div>
  );
};

export default CreateFormulario;
